import { render } from "./CaseHistory.vue?vue&type=template&id=740a00d7&scoped=true&ts=true"
import script from "./CaseHistory.vue?vue&type=script&lang=ts"
export * from "./CaseHistory.vue?vue&type=script&lang=ts"

import "./CaseHistory.vue?vue&type=style&index=0&id=740a00d7&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740a00d7"]])

export default __exports__